import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../login/cliente_login";
import { DatosGeneralesEntity } from "../entities/datos_generales_entity";
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { MovimientosConsulta, MovimientosEntity ,MovimientosDescripEntity} from "../entities/movimientos_entity";

declare var jQuery: any;

@Injectable()
export class MovimientosService {
    private userEmpresa: ClienteXCiudad;
    private url = "movimientos";

    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }
    consultarMovimientos(movimientoConsulta: MovimientosConsulta):Observable<MovimientosEntity[]>{
        let body = JSON.stringify(movimientoConsulta);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/resumenMovimientos", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    ConsultarDetalleMovimiento(movimientosEntity: MovimientosEntity):Observable<MovimientosDescripEntity[]>{
        let body = JSON.stringify(movimientosEntity);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/detalleMovimientos", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/movimientos/movimientos.service.ts